import { ReportType } from '@modeso/types__aumico-lib-annualreport-be';
import { ProjectStatus } from '../enums/project-status.enum';
import { ReportStatus } from '../enums/report-status.enum';
import { WorkflowDataTableValue } from './workflow-data-table-value.interface';

export interface ProjectOverviewTableValue {
    projectName: string;
    projectId: string;
    companyId: string;
    companyName: string;
    label?: string;
    balanceSheetDate: string;
    projectStatus: ProjectStatus;
    reportStatus: ReportStatus;
    reportType: ReportType;
    annualReportMetaData: string;
    assignee?: string | null;
    assigneeDeleted?: boolean;
    clerk?: string | null;
    clerkDeleted?: boolean;
    workflowData: WorkflowDataTableValue[] | null;
    isParentProject?: boolean;
    parentProjectId?: string;
    /** REV-22155 — tag names of the company. */
    tags?: string[];
    /** When the ABCP closing was started (setup wizard). Absent when it was not — or not known. */
    closingStartedAt?: string;
}
